/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledItemValidation = styled.div.attrs(() => ({
  className: '',
}))`
  display: flex;
  align-items: flex-start;
  color: ${(props) => props.color};
  font-size: ${(props) => `${props.fontSize}px`};
  margin-top: ${(props) => (props.fontSize === '14' ? '8px' : '12px')};
  line-height: ${(props) => (props.fontSize === '14' ? '16px' : '18px')};
  & img {
    margin-right: 8px;
    margin-top: 2px;
  }
`;
